import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_1169_18012)" }, [
      _createElementVNode("path", {
        fill: "#FF4C51",
        d: "M24 12c0 6.624-5.376 12-12 12-6.612 0-12-5.376-12-12C0 5.388 5.388 0 12 0c6.624 0 12 5.388 12 12M8.412 5.847 3.4 10.53c-.235.236-.306.447-.306.683 0 .212.07.435.306.67l5.012 4.706c.317.283.541.424.847.424.447 0 .741-.27.741-.553v-.294l-3.988-3.683c-.388-.353-.6-.8-.6-1.27s.2-.93.6-1.283L10 6.271v-.295c0-.294-.294-.576-.753-.576-.306 0-.506.141-.835.447m3.2 0-5 4.682c-.247.248-.318.447-.318.683 0 .212.07.423.318.67l5 4.706c.306.283.565.424.847.424.423 0 .741-.306.741-.753v-2.412h.188c2.46 0 4.036.624 5.106 2.694.212.388.506.47.788.47.353 0 .636-.305.636-.846 0-4.694-2-7.577-6.53-7.577H13.2V6.176c0-.411-.318-.776-.753-.776-.294 0-.506.141-.835.447"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_1169_18012" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }